<template>
  <div class="container">
    <header class="document-header">
      <h1 class="document-title">Akad Match Safety Standards</h1>
      <div class="header-divider"></div>
    </header>

    <section class="policy-section">
      <h2 class="section-title">Safety Commitment</h2>
      <p class="lead-text">
        Akad Match is committed to a safe and respectful community. We ensure <strong>strict content moderation</strong> using AI
        to block inappropriate images and enforce our <strong>age restriction policy</strong>.
      </p>
    </section>

    <section class="policy-section">
      <h2 class="section-title">Core Safety Policies</h2>
      <ul class="policy-list">
        <li class="policy-item">
          <span class="icon">🔞</span>
          <strong>Age Requirement:</strong> Users must confirm they are 18+ during registration.
        </li>
        <li class="policy-item">
          <span class="icon">✅</span>
          <strong>Optional Verification:</strong> Users can verify their ID for added trust but it is not mandatory.
        </li>
        <li class="policy-item">
          <span class="icon">🛡️</span>
          <strong>Content Moderation:</strong> AI automatically filters out inappropriate images.
        </li>
        <li class="policy-item">
          <span class="icon">📧</span>
          <strong>Secure Login:</strong> Access is protected via email and OTP authentication.
        </li>
      </ul>
    </section>

    <section class="policy-section">
      <h2 class="section-title">Reporting & Support</h2>
      <div class="notice-box">
        <p>For safety concerns, users can report issues through:</p>
        <ul class="report-channels">
          <li>📱 In-app reporting system</li>
          <li>📧 Contact us at <a href="mailto:cs@usmanheart.org" class="official-link">cs@usmanheart.org</a></li>
        </ul>
      </div>
    </section>

    <footer class="document-footer">
      <h3 class="footer-title">Safety Operations</h3>
      <dl class="contact-info">
        <dt>Email:</dt>
        <dd><a href="mailto:cs@usmanheart.org" class="official-link">cs@usmanheart.org</a></dd>
      </dl>
    </footer>
  </div>
</template>

<script>
export default {
  name: "SafetyStandards"
};
</script>

<style scoped>
.container {
  max-width: 850px;
  margin: 2rem auto;
  padding: 2.5rem;
  background: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-family: 'Segoe UI', system-ui, sans-serif;
  line-height: 1.6;
}

.document-header {
  margin-bottom: 2rem;
  border-bottom: 3px solid #2c3e50;
}

.document-title {
  color: #2c3e50;
  font-size: 2.2rem;
  margin-bottom: 1.2rem;
}

.section-title {
  color: #34495e;
  font-size: 1.6rem;
  margin: 1.5rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #ecf0f1;
}

.policy-list {
  padding-left: 1.8rem;
}

.policy-item {
  margin: 1rem 0;
  padding: 0.8rem;
  background: #f8f9fa;
  border-left: 4px solid #3498db;
  border-radius: 4px;
}

.notice-box {
  background: #f1f5f9;
  padding: 1.5rem;
  border-radius: 6px;
  margin: 1.5rem 0;
}

.official-link {
  color: #2980b9;
  text-decoration: none;
  font-weight: 500;
}

.official-link:hover {
  color: #3498db;
  text-decoration: underline;
}

.document-footer {
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #ecf0f1;
}

.contact-info {
  color: #7f8c8d;
}
</style>
